import React from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import DataLoader from '../data/DataLoader'
import TeamPage from '../teampage/TeamPage'
import AboutPage from './AboutPage'
import LegalPage from './LegalPage'
import Error404 from './Error404'

class StandardPage extends React.Component {


  constructor(){
    super()
    this.state = {
      currentPage: false
    }
  }


  findCurrentPage(props){

      let currentPage = props.pagesData.data.filter((item,index) => {
          return (item.slug === props.match.params.page)
      });


      (currentPage.length)?
        currentPage = currentPage[0]
      :
        currentPage = 404

      //console.log(currentPage);
      this.setState({currentPage})

  }

  componentWillMount(){
      (!this.state.currentPage && this.props.pagesData)?
        this.findCurrentPage(this.props)
      : null ;
  }

  componentWillUpdate(){
    //console.log("Standard Page Update",window.location);

    let location = window.location.pathname.split('/').join('')
    console.log(this.state.currentPage.slug, location,this.state.currentPage.slug !== location);
    (this.props.pagesData)?
      (this.state.currentPage.slug !== location)?
      (
        this.findCurrentPage(this.props),
        this.refs.wrapper.scrollTop = 0
      )
      :null
    : null
  }

  componentWillReceiveProps(newProps){


      (!this.state.currentPage && newProps.pagesData)?
      this.findCurrentPage(newProps)
      : null ;
  }

  render () {

    console.log('StandardPage',this.state.currentPage);

    let currentPage = this.state.currentPage;



    return (
        <DataLoader load='pages'>
          <div className="page-wrapper" ref="wrapper">
              {
                (currentPage && currentPage!==404)?

                (currentPage.template==='template-team.php')?
                      <TeamPage content={this.state.currentPage} />
                :(currentPage.template==='template-about.php')?
                  <AboutPage content={this.state.currentPage} />
                :(currentPage.template==='template-legal.php')?
                  <LegalPage content={this.state.currentPage} />
                : null


                :(currentPage===404)?
                  <Error404 />
                : null

              }
        </div>
        </DataLoader>
    )
  }
}

const mapStateToProps = (state) => {

    const pagesData = state.pagesData

    return{
      pagesData
    }
}

export default withRouter(connect(mapStateToProps)(StandardPage)) ;



// WEBPACK FOOTER //
// ./src/modules/pages/StandardPage.js